module.exports = __webpack_public_path__ + "static/img/065.b9e6d45.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/065.jpg
// module id = wCW/
// module chunks = 0